module.exports = __webpack_public_path__ + "img/service_image6.7f398c34.jpg";